import React, { memo } from "react";
import { MetricSummaryGrid, ButtonText } from "@loanbossinc/component-library";
import { Grid } from "@material-ui/core";

const CalculationPillBox = props => {
  const { cashflowModalIsVisible, showCashflows, calculations } = props;

  const MetricsData = [
    {
      title: "Refi Proceeds",
      metricValue: calculations?.loanProceeds?.maxProceeds,
      type: "CURRENCY"
    },
    {
      title: "Current Loan Balance",
      metricValue: calculations?.currentLoanBalance,
      type: "CURRENCY"
    },
    {
      title: "Closing Costs",
      metricValue: calculations?.closingCosts,
      type: "CURRENCY"
    },
    {
      title: "Prepayment Penalty",
      metricValue: calculations?.prepaymentPenalty,
      type: "CURRENCY"
    },
    {
      title: "Net Cashout",
      metricValue: calculations?.netCashout,
      type: "CURRENCY"
    },
    {
      title: "Interest Savings",
      metricValue: calculations?.costSavingsResult,
      type: "CURRENCY",
      hasAccountingFormat: true
    },
    {
      title: "PV01",
      metricValue: calculations?.pv01,
      type: "CURRENCY"
    },
    {
      title: "Breakeven Spread",
      metricValue: calculations?.breakevenSpread,
      type: "PERCENT",
      decimals: 2
    },
    {
      title: "Current Treasury",
      metricValue: calculations?.treasury,
      type: "PERCENT",
      decimals: 2
    },
    {
      title: "Breakeven Treasury",
      metricValue: calculations?.breakevenTreasury,
      type: "PERCENT",
      decimals: 2
    }
  ];

  return (
    <Grid container item direction="column">
      {cashflowModalIsVisible &&
        <Grid container item xs={3}>
          <ButtonText
            onClick={showCashflows}
            iconName="arrow_forward"
            label="View Cashflows"
          />
        </Grid>}
      <Grid container item xs={12} style={{ paddingTop: "0.5em" }}>
        <MetricSummaryGrid
          backgroundColor="#FAFAFA"
          options={MetricsData}
          titleOnTop
          small
        />
      </Grid>
    </Grid>
  );
};

export default memo(CalculationPillBox);
